import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../Dashboard/Invoice/Invoice.css";
import { useLocation } from "react-router-dom";
import AuthContext from "../../../../utils/secure-route/AuthContext";
import TableComponent from "../Dashboard/Invoice/PayInvoice_Table";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import { ToastContainer } from "react-toastify";
import { useToastHandler } from "../../../common/ToastHandler";
import AddVendorModal from "../ReusableForm/AddVendorModal";
import CustomDateInput from "../../../../context/CustomDateInput";
import useFormattingUtils from "../../../../context/useFormattingUtils";
import PaginatedSearchSelect from "../../../common/ReusableComponent/PaginatedSearchSelect/PaginatedSearchSelect";
import ChequeRenderer from "../Payroll/Cheque Layout/ChequeRenderer";

function PayInvoices() {
  const { Patch, GetPaginatedData } = useApi();
  const [reloadData, setReloadData] = useState(false);
  let { user } = useContext(AuthContext);
  const today = new Date().toISOString().split("T")[0];
  const navigate = useNavigate();
  const { formatDate, currency } = useFormattingUtils();
  const [, setActiveButton] = useState("");

  const location = useLocation();
  const { handleToast } = useToastHandler()
  useEffect(() => {
    setActiveButton(location.pathname);
  }, [location.pathname]);

  const [, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [showModal, setShowModal] = useState(false);
  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);
  const handleVendorAdded = (newVendor) => {
    setVendors((prevVendors) => [...prevVendors, newVendor]);
    setFormData({ ...formData, vendor_department: newVendor.id });
  };

  const [formData, setFormData] = useState({
    store_id: user.store,
    invoice_no: "",
    date: "",
    status: "paid",
    pay_method_status: "pay_now",
    pay_method: "cash",
    amount: "",
    remaining_amount: "",
    discount: 0,
    pay_amount: 0,
    after_discount: 0,
    prepaid_tax: true,
    vendor_department: "",
    vendor_department_name: "",
    cheque_no: null,
    note: "",
    due_date: null,
    bank: "",
  });

  const makeBlank = () => {
    setFormData({
      store_id: user.store,
      invoice_no: "",
      date: "",
      status: "paid",
      pay_method_status: "pay_now",
      pay_method: "cash",
      amount: "",
      remaining_amount: "",
      discount: 0,
      pay_amount: 0,
      after_discount: 0,
      prepaid_tax: true,
      vendor_department: "",
      vendor_department_name: "",
      cheque_no: null,
      note: "",
      due_date: null,
      bank: "",
    });
    setSelectedChequeLayout(null);
  };
  const [vendors, setVendors] = useState([]);
  const [banks, setBanks] = useState([]);
  const [, setFilteredInvoices] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState("");
  const [, setInitialAmount] = useState(null);
  const [selectedChequeLayout, setSelectedChequeLayout] = useState(null);

  const chequePreviewData = {
    name: formData.vendor_department_name || "",
    amount: formData.pay_amount || formData.amount || "0.00",
    date: formData.date || today,
    chequeNumber: formData.cheque_no || "",
    currency: currency,
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [vendorResponse, bankResponse, invoiceResponse] =
          await Promise.all([
            GetPaginatedData("vendorDepartmentData", {
              page: 1,
              search: "",
              queryParams: {}
            }),
            GetPaginatedData("bank", {
              page: 1,
              search: "",
              queryParams: {}
            }),
            GetPaginatedData("invoiceData", {
              page: 1,
              search: "",
              queryParams: {}
            }),
          ]);
        setVendors(vendorResponse?.data || []);
        setBanks(bankResponse?.data || []);
        setFilteredInvoices(invoiceResponse?.data || []);
      } catch (error) {
        console.error("Error fetching data:", error);
        handleToast({
          type: "ERROR",
          message: "Error fetching data:" + error
        })
      }
    };
    fetchData();
  }, [reloadData]);

  useEffect(() => {
    if (selectedVendor) {
      setFilteredInvoices((prevInvoices) =>
        prevInvoices.filter(
          (invoice) => invoice.vendor_department === selectedVendor
        )
      );
    }
  }, [selectedVendor]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "pay_method" && value !== "cheque") {
      setSelectedChequeLayout(null);
    }
    const parsedValue = parseFloat(value) || 0;
    if (name === "vendor_department") {
      setSelectedVendor(value);
      setFormData((prevData) => ({
        ...prevData,
        vendor_department: value,
        invoice_no: "",
        amount: "",
        pay_amount: 0,
        discount: 0,
        after_discount: 0,
      }));
    } else if (name === "discount") {
      setFormData((prevData) => {
        const newDiscount = parsedValue;
        const newPayAmount =
          prevData.pay_amount || prevData.remaining_amount || 0;
        const newAfterDiscount = Math.max(0, newPayAmount - newDiscount);
        return {
          ...prevData,
          discount: newDiscount,
          after_discount: newAfterDiscount,
        };
      });
    } else if (name === "pay_amount") {
      setFormData((prevData) => {
        const newPayAmount = parsedValue;

        const newAfterDiscount = Math.max(0, newPayAmount - prevData.discount);

        return {
          ...prevData,
          pay_amount: newPayAmount,
          after_discount: newAfterDiscount,
        };
      });
    } else {
      setFormData((prevData) => ({ ...prevData, [name]: value }));
    }
  };

  const handleInvoiceSelect = (invoice) => {
    if (invoice) {
      setFormData((prevData) => ({
        ...prevData,
        id: invoice.id,
        invoice_no: invoice.invoice_no,
        amount: invoice.amount,
        remaining_amount: invoice.remaining_amount || invoice.amount,
        pay_amount: invoice.remaining_amount || invoice.amount,
        discount: 0,
        after_discount: invoice.remaining_amount || invoice.amount,
        vendor_department: invoice.vendor_department,
        vendor_department_name: invoice.vendor_department_name,
        date: invoice.date || "",
      }));
      setInitialAmount(invoice.amount);
    } else {
      setFormData({
        id: "",
        invoice_no: "",
        amount: "",
        remaining_amount: "",
        pay_amount: "",
        discount: 0,
        after_discount: "",
        vendor_department: "",
        vendor_department_name: "",
        date: "",
      });
      setInitialAmount("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.pay_method) {
      handleToast({
        type: "ERROR",
        message: "Please select a payment method before submitting"
      })
      return;
    }

    const payAmount = parseFloat(formData.pay_amount);
    const previousRemainingAmount = parseFloat(formData.remaining_amount) || 0;
    const newRemainingAmount = previousRemainingAmount - payAmount;
    if (newRemainingAmount < 0) {
      handleToast({
        type: "ERROR",
        message: "Payment amount exceeds the remaining amount. Please enter a valid amount"
      })
      return;
    }

    const status = newRemainingAmount <= 0 ? "paid" : "partially_paid";
    const finalRemainingAmount =
    newRemainingAmount <= 0 ? "0.00" : newRemainingAmount.toFixed(2);
    const afterDiscount = formData.discount === 0 ? 0 : formData.after_discount;

    let updatedFormData = {
      ...formData,
      remaining_amount: finalRemainingAmount,
      status: status,
      cheque_no: formData.pay_method === "cheque" ? formData.cheque_no : null,
      bank: formData.pay_method === "bank" ? formData.bank : null,
      after_discount: afterDiscount,
      cheque_layout:
        formData.pay_method === "cheque"
          ? selectedChequeLayout?.id || null
          : null,
    };

    if (updatedFormData.pay_method_status !== "credit_invoice") {
      updatedFormData = {
        ...updatedFormData,
        pay_method_status: "credit_invoice",
      };
    }
    try {
      if (!updatedFormData.id) {
        handleToast({
          type: "ERROR",
          message: "No invoice selected. Please select an invoice before submitting"
        })
        return;
      }

      const response = await Patch(
        `invoiceData`,
        updatedFormData.id,
        updatedFormData
      );

      if (response && response.status === 200) {

        handleToast({
          type: "SUCCESS",
          message: "Invoice payment submitted successfully"
        })
        setReloadData(!reloadData);
        makeBlank();
      } else {
        setReloadData(!reloadData);

        console.error("Failed to submit:", response.data);

        handleToast({
          type: "ERROR",
          message: `Error: ${response.data.message || "Failed to update invoice."}`
        })
      }
    } catch (error) {
      setReloadData(!reloadData);
      console.error("Error:", error);

      handleToast({
        type: "ERROR",
        message: `An unexpected error occurred: ${error.message || "Please try again later."
          }`
      })
    }
  };

  const handleCancel = () => {
    makeBlank();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  // const handleLinkClick = (path) => {
  //   setIsOpen(false);
  //   navigate(path);
  // };
  const grandTotal = formData.after_discount || formData.pay_amount || 0;

  return (
    <div className="">
      <div className="responsive-box">

        <div
          className=""
        >

          <form onSubmit={handleSubmit}>
            <div style={{ display: "flex", alignItems: "center", marginLeft: "20px", marginBottom: "20px" }}>
              <h3 className="mb-1" style={{ margin: "0" }}>Pay Invoice</h3>
            </div>
            <div className=""></div>
            <div
              className="col-md-12 row"
              style={{
                gap: "12%",
                paddingLeft: "3%",
              }}
            >
              <div className="mb-3 col-md-3">
                <CustomDateInput
                  name="date"
                  className="form-control-borderless"
                  value={formData.date || today}
                  onChange={handleChange}
                  readOnly={true}
                // inputStyle={{border:"none"}}
                />
              </div>

              <div className="mb-3 col-md-3">
                <select
                  style={{
                    backgroundColor: "#ffffff",
                    border: "none",
                    borderBottom: "1px solid #ccc",
                    borderRadius: "0px",
                    height: "52px",
                  }}
                  className="input-select"
                  name="vendor_department"
                  value={formData.vendor_department}
                  onChange={(e) => {
                    const selectedValue = e.target.value;
                    if (selectedValue === "add-vendor") {
                      handleShow();
                      setFormData((prevData) => ({
                        ...prevData,
                        vendor_department: "",
                      }));
                    } else {
                      handleChange(e);
                    }
                  }}
                >
                  <option value="">Select Vendor</option>
                  <option value="add-vendor">Add Vendor</option> { }
                  {vendors
                    .filter((vendor) => !vendor.is_deleted)
                    .map((vendor) => (
                      <option key={vendor.id} value={vendor.id}>
                        {vendor.name}
                      </option>
                    ))}
                </select>
              </div>

              <div
                className="mb-3 col-md-3"
                style={{ position: "relative", marginTop: "4px" }}
              >
                <input
                  name="invoice_no"
                  type="text"
                  className="form-control-invoice"
                  value={formData.invoice_no}
                  placeholder=""
                  onChange={handleChange}
                />
                <label
                  htmlFor="invoice_no"
                  className="floating-label-invoice"
                  style={{ marginLeft: "12px" }}
                >
                  Invoice Number
                </label>
              </div>
            </div>

            <div
              className="mb-3 col-md-12 row mt-3"
              style={{ gap: "40px", marginLeft: "2%" }}
            >
              <div
                className="col-md-3"
                style={{ position: "relative", marginTop: "12px" }}
              >
                <input
                  style={{
                    backgroundColor: "#fafafa",
                    borderRadius: "0px",
                    height: "40px",
                    border: "1px solid #E9E9E9",
                    paddingLeft: "5px",
                    marginLeft: "5px",
                  }}
                  name="amount"
                  type="text"
                  className="form-control-invoice"
                  value={formData.amount}
                  readOnly
                  placeholder=""
                />
                <label
                  htmlFor="amount"
                  className="floating-label-invoice"
                  style={{ marginLeft: "20px" }}
                >
                  Amount
                </label>
              </div>
              <div
                className="col-md-2"
                style={{ position: "relative", marginTop: "19px" }}
              >
                <input
                  type="text"
                  className="form-control-invoice"
                  name="pay_amount"
                  maxLength={10}
                  placeholder=""
                  value={formData.pay_amount || ""}
                  onChange={handleChange}
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/[^0-9.]/g, "")
                      .replace(/^(\d*\.?\d{0,2}).*/g, "$1")
                      .slice(0, 10);
                  }}
                />
                <label
                  htmlFor="amount"
                  className="floating-label-invoice"
                  style={{ marginLeft: "12px" }}
                >
                  Pay Amount
                </label>
              </div>
              <div
                className="col-md-2"
                style={{ position: "relative", marginTop: "19px" }}
              >
                <input
                  type="number"
                  className="form-control-invoice "
                  name="discount"
                  value={formData.discount || ""}
                  onChange={handleChange}
                  placeholder=""
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .replace(/[^0-9.]/g, "")
                      .slice(0, 7);
                  }}
                />
                <label
                  htmlFor="amount"
                  className="floating-label-invoice"
                  style={{ marginLeft: "12px" }}
                >
                  Enter Discount
                </label>
              </div>

              <div
                className="col-md-3"
                style={{ position: "relative", marginTop: "19px" }}
              >
                <input
                  type="text"
                  style={{
                    backgroundColor: "#fafafa",
                    borderRadius: "0px",
                    height: "40px",
                    border: "1px solid #E9E9E9",
                    paddingLeft: "5px",
                    marginLeft: "5px",
                  }}
                  className="form-control-invoice"
                  placeholder=""
                  value={grandTotal || ""}
                  readOnly
                />
                <label
                  htmlFor="amount"
                  className="floating-label-invoice"
                  style={{ marginLeft: "20px" }}
                >
                  Grand Total
                </label>
              </div>
            </div>

            <div
              className="md-col-12 "
              style={{ marginLeft: "3%", marginTop: "35px" }}
            >
              <div
                className="d-flex align-items-center"
                style={{
                  border: "1px solid #ACB4AA",
                  padding: "5px",
                  width: "fit-content",
                  borderRadius: "40px",
                }}
              >
                {["cash", "bank", "cheque"].map((method) => (
                  <div className="" key={method}>
                    <input
                      type="radio"
                      className="form-check-input"
                      name="pay_method"
                      value={method}
                      checked={formData.pay_method === method}
                      onChange={handleChange}
                      id={`pay_method_${method}`}
                      style={{ display: "none" }}
                    />
                    <label
                      className="form-check-label cursor-pointer"
                      htmlFor={`pay_method_${method}`}
                      onClick={() =>
                        handleChange({
                          target: { name: "pay_method", value: method },
                        })
                      }
                      style={{
                        color:
                          formData.pay_method === method ? "white" : "#282e26",
                        backgroundColor:
                          formData.pay_method === method
                            ? "#4a5546"
                            : "transparent",
                        padding: "5px 25px",
                        borderRadius: "20px",
                      }}
                    >
                      {method.charAt(0).toUpperCase() + method.slice(1)} { }
                    </label>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-md-12 mt-4" style={{ marginLeft: "40px" }}>
              {formData.pay_method === "cheque" && (
                <div className="row">

                  {/* Bank */}
                  <div className="col-md-2 mb-3">
                    <select
                      style={{
                        backgroundColor: "#ffffff",
                        border: "none",
                        borderBottom: "1px solid #ccc",
                        borderRadius: "0px",
                        height: "52px",
                      }}
                      required
                      className="input-select"
                      name="bank"
                      value={formData.bank}
                      onChange={handleChange}
                    >
                      <option value="">Select Bank</option>
                      {banks.map((bank) => (
                        <option key={bank.id} value={bank.id}>
                          {bank.name}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Cheque Number */}
                  <div className="col-md-2 mb-3" style={{ position: "relative" }}>
                    <input
                      required
                      type="text"
                      className="form-control-invoice"
                      name="cheque_no"
                      placeholder=""
                      value={formData.cheque_no || ""}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (/^\d{0,15}$/.test(val)) {
                          handleChange(e);
                        }
                      }}
                    />

                    <label
                      className="floating-label-invoice"
                      style={{ marginLeft: "12px" }}
                    >
                      Cheque Number
                    </label>
                  </div>

                  {/* Cheque Layout */}
                  <div className="col-md-4 mb-4" style={{marginTop:"15px"}}>

                    <PaginatedSearchSelect
                      api="preferenceCompanyData"
                      GetPaginatedData={GetPaginatedData}
                      placeholder="Select Cheque Layout"
                      value={selectedChequeLayout}
                      getOptionLabel={(opt) => opt.layout_name}
                      onSelect={(opt) => setSelectedChequeLayout(opt)}
                    />

                  </div>

                </div>
              )}
              {selectedChequeLayout && (
                <div className="row mt-4 mx-3">
                  <div className="col-12">
                    <h6 style={{ marginBottom: "10px" }}>Cheque Preview</h6>
                    <div
                      style={{
                        background: "#f8f9fa",
                        padding: "10px",
                        borderRadius: "8px",
                        overflowX: "auto",
                      }}
                    >
                      <ChequeRenderer
                        layout={selectedChequeLayout}
                        chequeData={chequePreviewData}
                        showPrint
                      />
                    </div>
                  </div>
                </div>
              )}

              {formData.pay_method === "bank" && (
                <div className="mb-3">
                  <div className="col-md-6 row">
                    <div className="mb-3 col-md-6">
                      <select
                        style={{
                          backgroundColor: "#ffffff",
                          border: "none",
                          borderBottom: "1px solid #ccc",
                          borderRadius: "0px",
                          height: "52px",
                        }}
                        required
                        className="input-select"
                        name="bank"
                        value={formData.bank}
                        onChange={handleChange}
                      >
                        <option value="">Select Bank</option>
                        {banks.map((bank) => (
                          <option key={bank.id} value={bank.id}>
                            {bank.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              )}

              {formData.pay_method === "Bank Card (ACH/EFT)" && (
                <div className="mb-3">
                  <div className="col-md-12 row">
                    <div className="mb-3 col-md-6">
                      <select
                        style={{
                          backgroundColor: "#ffffff",
                          border: "none",
                          borderBottom: "1px solid #ccc",
                          borderRadius: "0px",
                          height: "52px",
                        }}
                        className="input-select"
                        name="bank"
                        value={formData.bank}
                        onChange={handleChange}
                      >
                        <option value="">Select Bank</option>
                        {banks.map((bank) => (
                          <option key={bank.id} value={bank.id}>
                            {bank.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="d-flex justify-content-end" style={{ gap: "15px" }}>
              <button
                type="button"
                className="btn btn-contained me-2"
                onClick={handleCancel}
                style={{
                  border: " 1px solid #282e26",
                  borderRadius: "20px",
                  width: "150px",
                  height: "38px",
                  fontWeight: "bold",
                }}
              >
                Clear
              </button>
              <button
                type="submit"
                className="btn"
                style={{
                  color: "white",
                  backgroundColor: "#282e26",
                  borderRadius: "40px",
                  width: "150px",
                  height: "38px",
                  fontWeight: "bold",
                }}
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
      <div
        className="responsive-box"
      >
        <TableComponent reloadData={reloadData} onEdit={handleInvoiceSelect} />
        <ToastContainer />
        <AddVendorModal
          show={showModal}
          handleClose={handleClose}
          onVendorAdded={handleVendorAdded}
        />
      </div>
    </div>
  );
}

export default PayInvoices;